import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import '../props/notifications-active-count';

class NotificationsActiveCountIcon extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      notifications-active-count {
        font-weight: bold;
        color: var(--notifications-active-count-icon-text-color, var(--white-base));
        background-color: var(--notifications-active-count-icon-box-color, var(--blue-40));
        border-radius: 6px;
        border: 1px solid var(--blue-40);
        box-shadow: 0 0 2px var(--blue-40);
        text-shadow: 0 0 1px var(--blue-40);
        padding: 5px 4px 4px 4px;
        display: inline-block;
        line-height: 1em;
        font-size: 90%;
      }
    `];
  }

  render() {
    return html`
      <notifications-active-count .href="${this.href}" maxcount="99"></notifications-active-count>
    `;
  }
}

window.customElements.define('notifications-active-count-icon', NotificationsActiveCountIcon);
